import "./BillionaireLayout.css";
import { type BillionaireItem, type ForbesResult, escapeHtml, formatWorth, updatedLabel } from "./BillionaireTypes";

function bornText(person: BillionaireItem): string {
  if (!person.birth_date) return "";
  const date = new Date(`${person.birth_date}T00:00:00`);
  const label = Number.isFinite(date.getTime())
    ? date.toLocaleDateString([], { month: "long", day: "numeric", year: "numeric" })
    : person.birth_date;
  return person.age ? `${label} (${person.age} years)` : label;
}

export function renderBillionaireLayout(container: HTMLElement, person: BillionaireItem, sourceUrl: string, forbes?: ForbesResult): void {
  const image = person.image_url
    ? `<img class="billionaire-layout-photo" src="${escapeHtml(person.image_url)}" alt="${escapeHtml(person.name)}" loading="eager" referrerpolicy="no-referrer" />`
    : `<div class="billionaire-layout-photo placeholder">${escapeHtml(person.name.charAt(0))}</div>`;

  container.innerHTML = `
    <div class="billionaire-layout-shell">
      <section class="billionaire-layout-panel">
        <div class="billionaire-layout-hero">
          ${image}
          <div class="billionaire-layout-title">
            <div class="billionaire-layout-kicker">BILLIONAIRE</div>
            <h1>${escapeHtml(person.name)}</h1>
            <p>#${person.rank} in the world · ${escapeHtml(formatWorth(person.net_worth_usd))}</p>
          </div>
        </div>

        <section class="billionaire-layout-about">
          <h2>About ${escapeHtml(person.name)}</h2>
          <p>${escapeHtml(person.about || `${person.name} is tracked in AyeSearch's Forbes Real-Time Billionaires cache.`)}</p>
          <a href="${escapeHtml(sourceUrl)}" target="_blank" rel="noopener noreferrer">Forbes</a>
        </section>

        <section class="billionaire-layout-facts">
          <h2>Quick facts</h2>
          ${person.birth_date ? `<div><span>Born</span><strong>${escapeHtml(bornText(person))}</strong></div>` : ""}
          ${person.country ? `<div><span>Citizenship</span><strong>${escapeHtml(person.country)}</strong></div>` : ""}
          ${person.source_of_wealth ? `<div><span>Source of wealth</span><strong>${escapeHtml(person.source_of_wealth)}</strong></div>` : ""}
          <div><span>World rank</span><strong>#${person.rank}</strong></div>
          <div><span>Net worth</span><strong>${escapeHtml(formatWorth(person.net_worth_usd))}</strong></div>
        </section>

        <div class="billionaire-layout-updated">${escapeHtml(updatedLabel(person.last_seen_at))} · cached by AyeSearch</div>
      </section>

      <section class="billionaire-forbes-result">
        <div class="billionaire-forbes-label">FORBES</div>
        <a class="billionaire-forbes-url" href="${escapeHtml(forbes?.url || person.profile_url || sourceUrl)}" target="_blank" rel="noopener noreferrer">forbes.com</a>
        <h2><a href="${escapeHtml(forbes?.url || person.profile_url || sourceUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(forbes?.title || `${person.name} - Forbes`)}</a></h2>
        <p>${escapeHtml(forbes?.description || `Forbes Real-Time Billionaires profile and ranking data for ${person.name}.`)}</p>
      </section>
    </div>
  `;
}
